import { Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import DesignServicesIcon from '@mui/icons-material/DesignServices'
import SearchIcon from '@mui/icons-material/Search'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import BuildIcon from '@mui/icons-material/Build'
import { Card, Icon } from '@/components/common'
import { ServiceCard as ServiceCardType } from '@/types'

/**
 * Service card props
 */
export interface ServiceCardProps {
  /** Service data */
  service: ServiceCardType
}

/**
 * Icon mapping for services
 */
const serviceIcons = {
  DesignServices: DesignServicesIcon,
  Search: SearchIcon,
  TrendingUp: TrendingUpIcon,
  Build: BuildIcon,
}

/**
 * ServiceCard Component
 * Displays a single service offering
 */
export const ServiceCard = ({ service }: ServiceCardProps) => {
  const IconComponent = serviceIcons[service.icon as keyof typeof serviceIcons] || DesignServicesIcon

  return (
    <Card
      hover
      elevation={1}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        p: 3,
      }}
    >
      <Icon
        icon={IconComponent}
        size="large"
        color="primary"
        sx={{
          fontSize: '3rem',
          mb: 2,
        }}
      />
      
      <Typography
        variant="h5"
        component="h3"
        sx={{
          fontWeight: 600,
          mb: 2,
        }}
      >
        {service.title}
      </Typography>
      
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          mb: 2,
          lineHeight: 1.6,
        }}
      >
        {service.description}
      </Typography>

      <List dense sx={{ mt: 'auto' }}>
        {service.bulletPoints.map((point, index) => (
          <ListItem key={index} disablePadding sx={{ mb: 0.5 }}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <CheckIcon color="primary" fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={point}
              primaryTypographyProps={{
                variant: 'body2',
                color: 'text.secondary',
              }}
            />
          </ListItem>
        ))}
      </List>
    </Card>
  )
}
